import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTheme } from "../redux/slices/themeSlice.js";
import { useColorScheme } from "@mui/material";
import { THEMES } from "../utils/constants.js";

export const useThemeController = () => {
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.theme.mode);
  const { setMode } = useColorScheme();

  const applyTheme = useCallback(
    (theme = mode) => {
      const body = document.body;

      body.classList.remove(THEMES.LIGHT, THEMES.DARK);
      body.classList.add(theme);

      localStorage.setItem("theme", theme);
      dispatch(setTheme(theme));
      setMode(theme);
    },
    [dispatch, mode]
  );

  const setLightTheme = useCallback(() => {
    applyTheme(THEMES.LIGHT);
  }, [applyTheme]);

  const setDarkTheme = useCallback(() => {
    applyTheme(THEMES.DARK);
  }, [applyTheme]);

  useEffect(() => {
    applyTheme(mode);
  }, [mode, applyTheme]);

  return {
    mode,
    setLightTheme,
    setDarkTheme,
  };
};
